//
// Copyright 2023 DXOS.org
//

export const DXOS_VERSION = '0.10.0';
